import _extends from "@babel/runtime/helpers/extends";
import React, { useMemo } from 'react';
import Select from './Select';
import { RadioOption } from './components/input-options';
const RadioSelect = /*#__PURE__*/React.memo(({
  components,
  ...props
}) => {
  const mergedComponents = useMemo(() => ({
    ...components,
    Option: RadioOption
  }), [components]);
  return /*#__PURE__*/React.createElement(Select, _extends({}, props, {
    isMulti: false,
    components: mergedComponents
  }));
});
export default RadioSelect;